import React, { useContext } from 'react';
import { array } from 'prop-types';
import { AppContext } from '../AppContext';

import MapIcon from './MapIcon';

const MobileAllPlaces = ({ className, filtered }) => {
  const { onClick, theme } = useContext(AppContext);

  /*const allPlaces = filtered.map((item, index) => {
    return (
      <button
        key={index}
        onClick={onClick}
        className={className}
        style={{ textAlign: 'left' }}
      >
        <span>{item.value}</span>
        {item.data && (
          <div className="autocomplete-group">
            {item.data && item.data.location}
          </div>
        )}
      </button>
    );
  });*/

  const allPlaces = filtered.map((item, index) => {
    if (!item.data) {
      // cities, states, and countries
      return (
        <button
          key={index}
          onClick={onClick}
          className={className}
          style={{ textAlign: 'left' }}
          data-value={item.data && item.data.location}
        >
          <MapIcon alt={theme.alt} src={theme.src} />
          <span>{item.value.replace(/,\s?,/g, ',')}</span>
        </button>
      );
    } else if(item.data) {
      return(
        <React.Fragment key="__thek">
          {item.data.location
            ? <button
            key={index}
            onClick={onClick}
            className={className}
            style={{ textAlign: 'left' }}
            data-value={item.value}
          >
            <span>{item.value}</span>
            {item.data && (
              <div className="autocomplete-group">
                {item.data && item.data.location.replace(/,\s?,/g, ',')}
              </div>
            )}
          </button>
            : <button
            key={index}
            onClick={onClick}
            className= "autocomplete-suggestion keywords"
            style={{ textAlign: "left" }}
          >
            <span className="keywords" data-value={item.code}>{item.name}</span>
            {item.data && (
              <div className="autocomplete-group">
                {item.data && <span>Keywords</span>}
              </div>
            )}
          </button>}
        </React.Fragment>
      )
    }
  });

  return allPlaces;
};

MobileAllPlaces.propTypes = {
  filtered: array.isRequired
};

export default MobileAllPlaces;
